<script lang="ts">
  import { theme } from "../theme";

  function flip() {
    theme.update((t) => (t === "light" ? "dark" : "light"));
  }
</script>

<button
  type="button"
  class="px-3 py-1.5 rounded-pill border border-border bg-bg-raised
         text-text-muted hover:text-text hover:border-border-strong
         transition-colors text-sm leading-none w-9 h-9 flex items-center justify-center"
  on:click={flip}
  aria-label={`Switch to ${$theme === "light" ? "dark" : "light"} theme`}
  aria-pressed={$theme === "light"}
  title={`Switch to ${$theme === "light" ? "dark" : "light"} theme`}
>
  {$theme === "light" ? "☾" : "☀"}
</button>
